import { useMutation } from "@tanstack/react-query";
import { makeCRMApi } from "../CrmApi";
import { IFilterSearch } from "../types/DirectoryEntry";

export const useSubscribeToAllNotificationsMutation = () => {
  const crmApi = makeCRMApi();
  
  const subscribeToAllNotificationsMutation = useMutation({
    mutationKey: ['crm-subscribe-to-all-notifications'],
    mutationFn: (filter: IFilterSearch) => crmApi.postSubscriptionToAllNotifications(filter),
  });
  
  return subscribeToAllNotificationsMutation;
}

export const useUnsubscribeFromAllNotificationsMutation = () => {
  const crmApi = makeCRMApi();
  
  const unsubscribeFromAllNotificationsMutation = useMutation({
    mutationKey: ['crm-unsubscribe-from-all-notifications'],
    mutationFn: (filter: IFilterSearch) => crmApi.deleteSubscriptionFromAllNotifications(filter),
  });
  
  return unsubscribeFromAllNotificationsMutation;
}
